export const invite = {
    fuwutiaokuan: "《Hizmet Şartları》",
    yinsizhengce: "《Gizlilik Politikası》",
    fzcg: "Kopyalama Başarılı",
    yqhy: "Arkadaşını Davet Et",
    fxlj: "Bağlantıyı Paylaş",
    register_now: "Hemen Kaydol",
    phone: "Telefon",
    email: "E-posta",
    placehold_phone: "Lütfen telefon numaranızı girin",
    placehold_email: "Lütfen e-posta adresinizi girin",
    placehold_code: "Davet Kodu",
    argee: "Okudum ve kabul ediyorum",
    agreement: "《BiKing Kullanıcı Sözleşmesi》",
    register: "Kaydol",
    phone_code: "SMS Doğrulama Kodu",
    email_code: "E-posta Doğrulama Kodu",
    code_to_phone: "Doğrulama kodu SMS olarak telefonunuza gönderildi",
    code_to_email: "Doğrulama kodu e-posta olarak adresinize gönderildi",
    has_sent: "Doğrulama kodu şuraya gönderildi:",
    resend: "Yeniden Gönder",
    send_code: "Doğrulama Kodunu Gönder",
    unable_code: "Doğrulama kodunu alamıyor musunuz?",
    set_pwd: "Şifre Belirle",
    placehold_pwd: "Lütfen şifrenizi girin",
    submit: "Gönder",
    error_phone: "Lütfen geçerli bir telefon numarası girin",
    error_email: "E-posta formatı hatalı, lütfen tekrar girin",
    error_checked: "Lütfen önce sözleşmeyi onaylayın",
    text: "Şifre formatı hatalı, şifre 8-32 karakter arası olmalı ve büyük/küçük harf ile rakam içermelidir.",
    validate: "Lütfen doğrulamayı tamamlayın",
    register_success: "Kayıt başarılı!",
    welcome: "Biking'e Hoş Geldiniz",
    start_trade: "Kripto para yatırarak işleme başlayın",
    safe: "Çeşitli yatırma yöntemleri, güvenli ve kolay kripto para işlemleri",
    pay_type: "Banka kartı veya diğer ödeme yöntemleriyle kripto para alın/satın",
    right_now_download: "Hemen İndirmeye Git",
    right_download: "İndirmeye Git",
    Please_enter_correct_phone_number: "Lütfen geçerli bir telefon numarası girin",
    Referral_code: "Lütfen davet kodunuzu girin",
    I_have_read_and_agree: "Okudum ve kabul ediyorum",
    BiKing_User_Agreement: "《BiKing Kullanıcı Sözleşmesi》",
    Please_enter_password: "Lütfen şifrenizi girin",
    Email_verification_code: "E-posta Doğrulama Kodu",
    SMS_code: "SMS Doğrulama Kodu",
    Incorrect_email_format_please_reenter: "E-posta formatı hatalı, lütfen tekrar girin",
    Please_read_and_agree_User_Agreement: "Lütfen kullanıcı sözleşmesini okuyun ve onaylayın",
    Sent_code_to: "Doğrulama kodu şuraya gönderildi:",
    zjff: "Doğrudan dağıtım!",
    ycxdz: "Tek seferde hesabınızda!",
    bbsy: "0 maliyetle 100x kazanç fırsatı!",
    sdly: "Biking'i tercih etmek için 3 neden",
    aqfktx: "Dünyanın en iyi güvenlik ve risk kontrol sistemi",
    aqhg: "Güvenli ve uyumlu, güvenilir değer ağı, profesyonel dağıtılmış altyapı ve DDOS saldırı önleme sistemi",
    qqbthyytd: "Küresel yerelleştirilmiş operasyon ekibi",
    qqbj: "Küresel erişim, birden fazla ülkede yerel hizmet, çoklu iş modeliyle blokzincir ekosistemi oluşturma",
    fwtx: "Kullanıcı odaklı hizmet sistemini yeniden şekillendirme",
    yhzs: "Kullanıcı önceliği, öncü tazminat mekanizması, kullanıcı koruma fonu oluşturulması",
    jslc: "Kilidi açma süreci",
    zcwcjkjs: "Kayıt tamamlandıktan sonra, 1188 USDT bonus hesap bakiyesi olarak dağıtılır, bonus hesabına girerek kilidi açabilirsiniz.",
    czts: "İşlem örneği: Başarılı kayıttan sonra aldığınız 1000 USDT ile 20x kaldıraçlı BTC long pozisyonu açtığınızda, BTC %1 yükseldiğinde %20 kâr elde edersiniz, yani 200 USDT, bu kâr doğrudan çekilebilir.",
    zhu: "Not:",
    qzlqyky: "1188 USDT tek seferde kısmi dağıtılır ve alınır, tüm kontrat türlerinde kullanılabilir",
    gqql: "1188 USDT kullanım süresi 1 aydır, süre sonunda sıfırlanır"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/tr.js